import React, { useState, useEffect } from "react";
import { C, text } from "../theme";
import { Notice } from "./ui";

// docType: "AOR" | "PO" | "GRN" | "INVOICE" | "VIREMENT"
// canManage: boolean — true if current user is the originator or an admin
export default function WatcherPanel({ docType, docId, canManage }) {
  const [watchers, setWatchers] = useState([]);
  const [users, setUsers] = useState([]);
  const [adding, setAdding] = useState("");
  const [notice, setNotice] = useState(null); // { kind: "success" | "error", text }
  const base = `/api/watchers/${docType}/${docId}`;

  const load = () => fetch(base).then(r => r.json()).then(d => setWatchers(Array.isArray(d) ? d : [])).catch(() => {});
  // Deliberate: refetch only when the doc changes; `load` is recreated each render but only reads `base`.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { if (docId) load(); }, [docId]);
  useEffect(() => { if (canManage) fetch("/api/me/users").then(r => r.json()).then(setUsers).catch(() => {}); }, [canManage]);

  const add = async () => {
    if (!adding) return;
    const res = await fetch(base, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ userId: adding }) });
    if (!res.ok) { setNotice({ kind: "error", text: "Error: " + (await res.json()).error }); return; }
    setAdding(""); load();
  };
  const remove = async (id) => { const res = await fetch(`${base}/${id}`, { method: "DELETE" }); if (!res.ok) { setNotice({ kind: "error", text: "Error: " + (await res.json()).error }); return; } load(); };

  return (
    <div style={{ border: `1px solid ${C.gray200}`, borderRadius: 8, padding: 12, marginTop: 12 }}>
      <div style={{ fontSize: text.sm, fontWeight: 700, color: C.gray600, marginBottom: 8 }}>👁 Watchers</div>
      <Notice notice={notice} onDismiss={() => setNotice(null)} style={{ marginBottom: 8 }} />
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: canManage ? 10 : 0 }}>
        {watchers.length === 0 && <span style={{ fontSize: text.sm, color: C.gray500 }}>No watchers.</span>}
        {watchers.map(w => (
          <span key={w.id} style={{ background: C.gray100, borderRadius: 12, padding: "3px 10px", fontSize: text.sm, display: "flex", alignItems: "center", gap: 6 }}>
            {w.user ? w.user.displayName : w.userId}
            {canManage && <button type="button" onClick={() => remove(w.id)} aria-label={`Remove watcher ${w.user ? w.user.displayName : w.userId}`} style={{ cursor: "pointer", color: C.danger, fontWeight: 700, background: "none", border: "none", padding: 0, fontSize: "inherit", fontFamily: "inherit" }}>×</button>}
          </span>
        ))}
      </div>
      {canManage && (
        <div style={{ display: "flex", gap: 8 }}>
          <select value={adding} onChange={e => setAdding(e.target.value)} aria-label="Add watcher" style={{ padding: "5px 8px", border: `1px solid ${C.gray300}`, borderRadius: 6, fontSize: text.sm }}>
            <option value="">+ add watcher…</option>
            {users.filter(u => !watchers.some(w => w.userId === u.id)).map(u => <option key={u.id} value={u.id}>{u.displayName} — {u.roleName}</option>)}
          </select>
          <button onClick={add} style={{ background: C.primary, color: C.white, border: "none", borderRadius: 6, padding: "5px 12px", fontSize: text.sm, fontWeight: 600, cursor: "pointer" }}>Add</button>
        </div>
      )}
    </div>
  );
}
